import * as Yup from 'yup'
import FormBuilder, { FormFields } from "app/modules/tp/builders/FormBuilder";
import { Provider } from '../../providers/_models';
import ReferentAPI from '../../referents/_requests';
import { Referent } from '../../referents/_models';
import {Mean} from "../../means/_models";
import {Driver} from "../../drivers/_models";


const generateFormFields = async () => {

    const response = await ReferentAPI.getAllNoPagination({});
    let referents : Array<Referent> = [];

    if(response?.success){
        referents = response.data as Array<Referent>;
    }

    const formFields: FormFields<Provider> = {
        title0: {
            type: "titleView",
            title: "Info",
            icon: <i className="fa-solid fa-handshake-simple"></i>,
            columnNo: 0,
        },
        id: {
            type: "text",
            key: "id",
            label: "# ID",
            attributes: {
                disabled: true
            },
            validation: Yup.number().integer().nullable(),
            columnNo: 0,
        },
        referents: {
            type: "select",
            key: "referents",
            label: "Referente",
            isMulti: true,
            options: referents.map((referent :Referent) => ({ value: (referent.id?.toString()),  label: `${referent.email} ${referent.name ?? ""} ${referent.surname ?? ""}`})),
            columnNo: 0,
        },
        name: {
            type: "text",
            key: "name",
            label: "Nome",
            validation: Yup.string()
                .max(50, 'Il nome visualizzato deve essere di massimo 50 caratteri')
                .required('Il nome è obbligatorio'),
            columnNo: 0,
        },
        title1: {
            type: "titleView",
            title: "Mezzi",
            icon: <i className="fa-solid fa-bus"></i>,
            columnNo: 1,
        },
        means: {
            type: "multiTextView",
            key: "means",
            stringifyFunction: (m: Mean) => `${m?.code ?? ""} ${m?.license_plate ?? ""} ${ m?.seats ? "/ "+m.seats+" pt" : "" } ${ m?.emission_class ? "/ "+m.emission_class : "" }`,
            columnNo: 1,
        },
        title2: {
            type: "titleView",
            title: "Autisti",
            icon: <i className="fa-solid fa-user"></i>,
            columnNo: 2,
        },
        drivers: {
            type: "multiTextView",
            key: "drivers",
            stringifyFunction: (d: Driver) => `${d?.name ? d.name : ""} ${d?.surname ? d?.surname : ""} ${d?.email ? `- ${d?.email}` : ""}`,
            columnNo: 2,
        }
    }
    return formFields;
}

const ProviderFormBuilder = async () => {
    const formFields = await generateFormFields();
    return FormBuilder<Provider>({ formFields })
}

export default ProviderFormBuilder;
